import classnames from 'classnames';
import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { noop } from 'rxjs';
import { MediaManagerSDKBoardSitesVisibility } from '../../../../constants/BoardSitesVisibility';
import { MediaManagerSDKBoardTeamAvailability } from '../../../../constants/BoardsTeamAvailability';
import { ContextMenuId } from '../../../../constants/ContextMenuId';
import { Text, Tooltip } from '../../../common';
import { BoardThumbnail } from '../../../common/Thumbnails/BoardThumbnail';
import { THUMBNAIL_SIZE } from '../../../common/Thumbnails/constants';
import { Users } from '../../../common/WixIcons';
import { GenericItem } from '../../Generic/GenericItem';
import { IBoard } from '../../types';
import { BoardActionsRow } from './BoardActionsRow';
import styles from './BoardCard.scss';

export const BoardCard: FC<IBoard> = ({
  className,
  item,
  selected,
  onClick = noop,
  onDoubleClick,
  onContextMenu,
  canDrag,
  selectedItems,
  currentFolder,
  boardCardExternalClassName,
}) => {
  const { name, sitesVisibility } = item;

  const handleClick = useCallback(
    (item, event) => {
      onClick(item, event);
    },
    [onClick],
  );

  const isSharedBoard = item.teamAvailability === MediaManagerSDKBoardTeamAvailability.On;

  return (
    <GenericItem
      item={item}
      className={classnames(styles.genericItem, className)}
      dataHook="board-card"
      contextMenuId={ContextMenuId.SelectedItems}
      selected={selected}
      onClick={handleClick}
      onDoubleClick={onDoubleClick}
      onContextMenu={onContextMenu}
      canDrag={canDrag}
      selectedItems={selectedItems}
    >
      {({ openContextMenu }) => (
        <div className={classnames(styles.boardCard, boardCardExternalClassName, { [styles.selected]: selected })}>
          <div className={styles.imagePhaseTwo}>
            <BoardThumbnail
              board={item}
              className={styles.boardImageHolder}
              imageClassName={styles.boardImage}
              {...THUMBNAIL_SIZE}
            />

            <BoardActionsRow
              className={styles.actionsRow}
              isAvailableOnAllSites={sitesVisibility === MediaManagerSDKBoardSitesVisibility.All}
              onOpenContextMenu={openContextMenu}
              onOpenButtonClick={onDoubleClick}
              item={item}
              currentFolder={currentFolder}
            />
          </div>

          <div className={styles.boardInfo}>
            <Text size="small" weight="bold" ellipsis dataHook="board-name" tagName="div">
              {name}
            </Text>
            {isSharedBoard && (
              <div className={styles.iconHolder} data-hook="team-share-icon">
                <Tooltip content={<FormattedMessage id="boards.teams.this-board-is-shared" />} appendTo="viewport">
                  <Users className={styles.usersIcon} />
                </Tooltip>
              </div>
            )}
          </div>
        </div>
      )}
    </GenericItem>
  );
};
